<template>
  <div class="paket-page" :class="device.desktop ? 'pa-6' : 'pa-0'">
    <v-row>
      <v-col cols="12">
        <v-card class="paket-card animated animate__bounceIn elevation-0">
          <div class="paket-toolbar">
            <div class="paket-toolbar__left">
              <div class="paket-toolbar__icon">
                <v-icon>mdi-package-variant-closed</v-icon>
              </div>
              <div>
                <div class="paket-toolbar__title">Paket Harga</div>
                <div class="paket-toolbar__sub">
                  {{ records.length || 0 }} paket tersedia
                </div>
              </div>
            </div>

            <div class="paket-toolbar__actions">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                placeholder="Cari paket..."
                single-line
                hide-details
                dense
                outlined
                color="#1f7a57"
                class="paket-search"
                clearable
              ></v-text-field>

              <v-tooltip bottom color="#0d4a36">
                <template v-slot:activator="{ on }">
                  <v-btn
                    icon
                    class="paket-icon-btn"
                    v-on="on"
                    v-show="page.actions.refresh"
                    @click="fetchRecords"
                  >
                    <v-icon>mdi-refresh</v-icon>
                  </v-btn>
                </template>
                <span>Muat ulang</span>
              </v-tooltip>

              <v-btn
                class="paket-btn-primary"
                v-show="page.actions.add"
                @click="openForm"
              >
                <v-icon left small>mdi-plus</v-icon>
                Tambah Paket
              </v-btn>
            </div>
          </div>

          <!-- Desktop table -->
          <v-data-table
            v-show="device.desktop"
            :headers="headers"
            :items="records"
            :items-per-page="table.options.itemsPerPage"
            :page.sync="table.options.page"
            class="paket-table"
            :loading="loading.table"
            loading-text="Memuat data paket..."
            :search="search"
            hide-default-footer
            @page-count="table.options.pageCount = $event"
          >
            <v-progress-linear
              slot="progress"
              color="#1f7a57"
              height="2"
              indeterminate
            ></v-progress-linear>

            <template v-slot:item.name="{ item }">
              <div class="paket-name-cell">
                <div class="paket-name-cell__mark">
                  {{ (item.name || 'P').charAt(0).toUpperCase() }}
                </div>
                <div>
                  <div class="paket-name-cell__title">{{ item.name }}</div>
                  <div class="paket-name-cell__hint">Paket langganan</div>
                </div>
              </div>
            </template>

            <template v-slot:item.description="{ value }">
              <span class="paket-desc">{{ value || '—' }}</span>
            </template>

            <template v-slot:item.price="{ value }">
              <span class="paket-price">{{ formatPrice(value) }}</span>
            </template>

            <template v-slot:item.max_wa="{ value }">
              <span class="paket-limit">{{ value || 1 }} nomor</span>
            </template>

            <template v-slot:item.features="{ item }">
              <div class="paket-features">
                <span
                  class="paket-chip"
                  :class="item.allow_text ? 'is-on' : 'is-off'"
                >Text</span>
                <span
                  class="paket-chip"
                  :class="item.allow_image ? 'is-on' : 'is-off'"
                >Image</span>
                <span
                  class="paket-chip"
                  :class="item.allow_document ? 'is-on' : 'is-off'"
                >Doc</span>
              </div>
            </template>

            <template v-slot:item.id="{ value }">
              <div class="paket-row-actions">
                <v-tooltip bottom color="#0d4a36">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      icon
                      small
                      class="paket-action-edit"
                      v-on="on"
                      v-show="page.actions.edit"
                      @click="editRecord(value)"
                    >
                      <v-icon small>mdi-pencil</v-icon>
                    </v-btn>
                  </template>
                  <span>Ubah</span>
                </v-tooltip>
                <v-tooltip bottom color="#0d4a36">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      icon
                      small
                      class="paket-action-delete"
                      v-on="on"
                      v-show="page.actions.delete"
                      @click="postDeleteRecord(value)"
                    >
                      <v-icon small>mdi-delete-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>Hapus</span>
                </v-tooltip>
              </div>
            </template>

            <template v-slot:no-data>
              <div class="paket-empty">
                <v-icon large color="#8fd6b5">mdi-package-variant</v-icon>
                <div class="paket-empty__title">Belum ada paket</div>
                <div class="paket-empty__sub">Tambahkan paket harga pertama Anda</div>
                <v-btn
                  class="paket-btn-primary mt-4"
                  small
                  v-show="page.actions.add"
                  @click="openForm"
                >
                  <v-icon left small>mdi-plus</v-icon>
                  Tambah Paket
                </v-btn>
              </div>
            </template>
          </v-data-table>

          <!-- Mobile cards -->
          <div class="paket-mobile" v-show="device.mobile">
            <div
              v-for="item in filterItems"
              :key="item.id"
              class="paket-mobile-card"
            >
              <div class="paket-mobile-card__top">
                <div class="paket-name-cell">
                  <div class="paket-name-cell__mark">
                    {{ (item.name || 'P').charAt(0).toUpperCase() }}
                  </div>
                  <div>
                    <div class="paket-name-cell__title">{{ item.name }}</div>
                    <div class="paket-price mt-1">{{ formatPrice(item.price) }}</div>
                    <div class="paket-mobile-meta mt-1">
                      {{ item.max_wa || 1 }} nomor WA ·
                      Text {{ item.allow_text ? '✓' : '✗' }} ·
                      Image {{ item.allow_image ? '✓' : '✗' }} ·
                      Doc {{ item.allow_document ? '✓' : '✗' }}
                    </div>
                  </div>
                </div>
                <v-menu bottom left origin="center center" transition="scale-transition">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon small v-bind="attrs" v-on="on" class="paket-icon-btn">
                      <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                  </template>
                  <v-list dense class="paket-menu">
                    <v-list-item
                      @click="editRecord(item.id || item.uuid)"
                      v-show="page.actions.edit"
                    >
                      <v-list-item-icon class="mr-2">
                        <v-icon small color="#1f7a57">mdi-pencil</v-icon>
                      </v-list-item-icon>
                      <v-list-item-title>Ubah Data</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                      @click="postDeleteRecord(item.id || item.uuid)"
                      v-show="page.actions.delete"
                    >
                      <v-list-item-icon class="mr-2">
                        <v-icon small color="#c62828">mdi-delete-outline</v-icon>
                      </v-list-item-icon>
                      <v-list-item-title>Hapus Data</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </div>
              <div class="paket-mobile-card__desc">
                {{ item.description || 'Tidak ada keterangan' }}
              </div>
            </div>

            <div v-if="!filterItems.length" class="paket-empty pa-8">
              <v-icon large color="#8fd6b5">mdi-package-variant</v-icon>
              <div class="paket-empty__title">Belum ada paket</div>
              <div class="paket-empty__sub">Tambahkan paket harga pertama Anda</div>
            </div>
          </div>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog
      transition="dialog-bottom-transition"
      v-model="form.add"
      :max-width="device.desktop ? '520px' : '100%'"
      persistent
      :fullscreen="device.mobile"
      content-class="paket-dialog"
    >
      <v-card class="paket-dialog-card">
        <div class="paket-dialog-header">
          <div class="paket-dialog-header__copy">
            <v-icon class="mr-2">mdi-package-variant-closed</v-icon>
            {{ form.edit ? 'Ubah Paket Harga' : 'Tambah Paket Harga' }}
          </div>
          <v-btn icon dark small @click="closeForm">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>

        <v-card-text class="paket-dialog-body">
          <div class="paket-field-label">Nama Paket</div>
          <v-text-field
            outlined
            color="#1f7a57"
            hide-details="auto"
            placeholder="Contoh: Starter, Pro, Business"
            v-model="record.name"
            dense
            class="paket-field mb-4"
            prepend-inner-icon="mdi-tag-outline"
          ></v-text-field>

          <div class="paket-field-label">Keterangan</div>
          <v-textarea
            outlined
            color="#1f7a57"
            hide-details="auto"
            placeholder="Jelaskan manfaat atau isi paket"
            v-model="record.description"
            dense
            rows="3"
            auto-grow
            class="paket-field mb-4"
            prepend-inner-icon="mdi-text"
          ></v-textarea>

          <div class="paket-field-label">Harga Paket</div>
          <v-text-field
            outlined
            color="#1f7a57"
            type="number"
            hide-details="auto"
            placeholder="Masukkan angka tanpa titik/koma"
            v-model="record.price"
            dense
            class="paket-field mb-4"
            prepend-inner-icon="mdi-cash"
            suffix="IDR"
          ></v-text-field>
          <div class="paket-price-preview mb-4" v-if="record.price">
            Preview: <strong>{{ formatPrice(record.price) }}</strong>
          </div>

          <div class="paket-field-label">Maks. Nomor WhatsApp</div>
          <v-text-field
            outlined
            color="#1f7a57"
            type="number"
            min="1"
            max="100"
            hide-details="auto"
            placeholder="Berapa nomor WA yang boleh didaftarkan"
            v-model.number="record.max_wa"
            dense
            class="paket-field mb-4"
            prepend-inner-icon="mdi-cellphone-wireless"
            suffix="nomor"
          ></v-text-field>

          <div class="paket-field-label">Fitur Pengiriman</div>
          <div class="paket-switches">
            <v-switch
              v-model="record.allow_text"
              label="Boleh kirim pesan teks"
              color="#1f7a57"
              hide-details
              dense
              class="mt-0"
            ></v-switch>
            <v-switch
              v-model="record.allow_image"
              label="Boleh kirim gambar"
              color="#1f7a57"
              hide-details
              dense
              class="mt-0"
            ></v-switch>
            <v-switch
              v-model="record.allow_document"
              label="Boleh kirim dokumen / file"
              color="#1f7a57"
              hide-details
              dense
              class="mt-0"
            ></v-switch>
          </div>
        </v-card-text>

        <v-divider class="paket-divider"></v-divider>
        <v-card-actions class="paket-dialog-actions">
          <v-btn text class="paket-btn-ghost" @click="closeForm">Batal</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            class="paket-btn-primary"
            v-show="!form.edit"
            @click="postAddNewRecord"
          >
            <v-icon left small>mdi-plus</v-icon>
            Tambah
          </v-btn>
          <v-btn
            class="paket-btn-primary"
            v-show="form.edit"
            @click="postUpdateRecord"
          >
            <v-icon left small>mdi-content-save</v-icon>
            Simpan
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import "animate.css";

export default {
  name: "MasterPaket",
  data: () => ({
    headers: [
      {
        text: "Nama Paket",
        align: "start",
        sortable: true,
        value: "name",
      },
      { text: "Keterangan", value: "description", sortable: false },
      {
        text: "Harga",
        align: "start",
        sortable: true,
        value: "price",
      },
      {
        text: "Max WA",
        align: "center",
        sortable: true,
        value: "max_wa",
        width: 100,
      },
      {
        text: "Fitur",
        align: "center",
        sortable: false,
        value: "features",
        width: 180,
      },
      {
        text: "Aksi",
        value: "id",
        width: 110,
        sortable: false,
        align: "center",
      },
    ],
    search: null,
  }),
  computed: {
    ...mapState([
      "page",
      "theme",
      "http",
      "device",
      "record",
      "records",
      "loading",
      "event",
      "snackbar",
      "form",
      "table",
    ]),
    filterItems() {
      if (!this.search) return this.records || [];
      const q = this.search.toLowerCase();
      return (this.records || []).filter((item) => {
        const name = (item.name || "").toLowerCase();
        const desc = (item.description || "").toLowerCase();
        return name.indexOf(q) > -1 || desc.indexOf(q) > -1;
      });
    },
  },
  created() {
    this.setPage({
      crud: true,
      dataUrl: "api/superadmin/master-data/paket",
      pagination: false,
      title: "MASTER PAKET HARGA",
      subtitle: "Berikut Daftar Seluruh Paket Harga Yang Tersedia",
      showtable: true,
      breadcrumbs: [
        {
          text: "Data Master",
          disabled: true,
          href: "",
        },
        {
          text: "Paket Harga",
          disabled: false,
          href: "",
        },
      ],
      actions: {
        refresh: true,
        add: true,
        edit: true,
        delete: true,
        bulkdelete: true,
        print: false,
        export: false,
        help: false,
      },
    });
    this.fetchRecords();
  },
  mounted() {},
  methods: {
    ...mapActions([
      "setPage",
      "fetchRecords",
      "postAddNew",
      "postEdit",
      "postUpdate",
      "postConfirmDelete",
      "assignFileBrowse",
      "setLoading",
      "setRecord",
      "setForm",
    ]),
    formatPrice(value) {
      const num = Number(value);
      if (Number.isNaN(num)) return value || "—";
      return new Intl.NumberFormat("id-ID", {
        style: "currency",
        currency: "IDR",
        minimumFractionDigits: 0,
      }).format(num);
    },
    openForm: function () {
      this.setForm({
        add: true,
        edit: false,
      });
      this.setRecord({
        max_wa: 1,
        allow_text: true,
        allow_image: false,
        allow_document: false,
      });
    },
    closeForm: function () {
      this.setForm({
        add: false,
        edit: false,
      });
    },
    postAddNewRecord: function () {
      this.postAddNew(this.record).then(() => {
        this.closeForm();
      });
    },
    editRecord: function (val) {
      this.postEdit(val);
      this.setForm({
        add: true,
        edit: true,
      });
    },
    postUpdateRecord: function () {
      this.postUpdate(this.record).then(() => {
        this.closeForm();
      });
    },
    postDeleteRecord: function (val) {
      this.postConfirmDelete(val);
    },
    postDownload(val) {
      window.open(val, "__blank");
    },
  },
};
</script>

<style scoped>
.paket-page {
  --gw-ink: #10241c;
  --gw-forest: #0d4a36;
  --gw-leaf: #1f7a57;
  --gw-mint: #8fd6b5;
  --gw-fog: #eef6f1;
  --gw-paper: #f8fbf9;
  --gw-line: #c9ddd3;
  --gw-muted: #5d7268;
}

.paket-card {
  border-radius: 14px !important;
  overflow: hidden;
  border: 1px solid var(--gw-line);
  background: #fff !important;
}

.paket-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  flex-wrap: wrap;
  padding: 1rem 1.15rem;
  background:
    radial-gradient(120% 80% at 0% 0%, #1a6b4d 0%, transparent 55%),
    linear-gradient(175deg, #0b3d2e 0%, #0f5c45 45%, #0a3327 100%);
  color: #f4fbf7;
}

.paket-toolbar__left {
  display: flex;
  align-items: center;
  gap: 0.85rem;
}

.paket-toolbar__icon {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  display: grid;
  place-items: center;
  background: linear-gradient(145deg, #b7ebcf, #8fd6b5);
  color: #0b3d2e;
}

.paket-toolbar__icon .v-icon {
  color: #0b3d2e !important;
}

.paket-toolbar__title {
  font-family: "Outfit", "Montserrat", sans-serif;
  font-weight: 700;
  font-size: 1.05rem;
  line-height: 1.2;
}

.paket-toolbar__sub {
  margin-top: 0.15rem;
  font-size: 0.75rem;
  color: rgba(244, 251, 247, 0.65);
}

.paket-toolbar__actions {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.paket-search {
  max-width: 260px;
  min-width: 180px;
}

.paket-search >>> .v-input__slot {
  background: rgba(255, 255, 255, 0.1) !important;
  border-radius: 10px !important;
  min-height: 38px !important;
}

.paket-search >>> fieldset {
  border-color: rgba(143, 214, 181, 0.35) !important;
}

.paket-search >>> input,
.paket-search >>> .v-icon {
  color: #f4fbf7 !important;
}

.paket-search >>> input::placeholder {
  color: rgba(244, 251, 247, 0.55) !important;
}

.paket-icon-btn {
  color: #f4fbf7 !important;
}

.paket-icon-btn:hover {
  background: rgba(143, 214, 181, 0.18) !important;
}

.paket-btn-primary {
  background: linear-gradient(145deg, #b7ebcf, #8fd6b5) !important;
  color: #0b3d2e !important;
  text-transform: none !important;
  letter-spacing: 0 !important;
  font-weight: 700 !important;
  border-radius: 10px !important;
  box-shadow: none !important;
}

.paket-btn-primary:hover {
  background: linear-gradient(145deg, #c8f0da, #9fdebf) !important;
}

.paket-table {
  background: transparent !important;
}

.paket-table >>> thead th {
  background: var(--gw-fog) !important;
  color: var(--gw-forest) !important;
  font-weight: 700 !important;
  font-size: 0.75rem !important;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  border-bottom: 1px solid var(--gw-line) !important;
}

.paket-table >>> tbody td {
  border-bottom: 1px solid var(--gw-line) !important;
  color: var(--gw-ink);
  height: 64px !important;
}

.paket-table >>> tbody tr:hover {
  background: rgba(143, 214, 181, 0.08) !important;
}

.paket-name-cell {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.paket-name-cell__mark {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  display: grid;
  place-items: center;
  flex-shrink: 0;
  font-family: "Outfit", "Montserrat", sans-serif;
  font-weight: 700;
  color: #0b3d2e;
  background: linear-gradient(145deg, #b7ebcf, #8fd6b5);
}

.paket-name-cell__title {
  font-weight: 600;
  color: var(--gw-ink);
  line-height: 1.2;
}

.paket-name-cell__hint {
  margin-top: 0.15rem;
  font-size: 0.72rem;
  color: var(--gw-muted);
}

.paket-desc {
  color: var(--gw-muted);
  font-size: 0.9rem;
}

.paket-price {
  display: inline-block;
  font-family: "Outfit", "Montserrat", sans-serif;
  font-weight: 700;
  color: var(--gw-forest);
  background: rgba(143, 214, 181, 0.18);
  border: 1px solid rgba(31, 122, 87, 0.18);
  border-radius: 8px;
  padding: 0.25rem 0.55rem;
  font-size: 0.85rem;
}

.paket-limit {
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--gw-ink);
}

.paket-features {
  display: flex;
  justify-content: center;
  gap: 0.35rem;
  flex-wrap: wrap;
}

.paket-chip {
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  padding: 0.2rem 0.45rem;
  border-radius: 6px;
}

.paket-chip.is-on {
  color: #0b3d2e;
  background: rgba(143, 214, 181, 0.35);
}

.paket-chip.is-off {
  color: var(--gw-muted);
  background: #f0f0f0;
}

.paket-switches {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  padding: 0.5rem 0.75rem;
  border-radius: 10px;
  background: var(--gw-fog);
  border: 1px solid var(--gw-line);
}

.paket-mobile-meta {
  font-size: 0.72rem;
  color: var(--gw-muted);
}

.paket-row-actions {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.15rem;
}

.paket-action-edit {
  color: var(--gw-leaf) !important;
}

.paket-action-delete {
  color: #c62828 !important;
}

.paket-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2.5rem 1rem;
  text-align: center;
}

.paket-empty__title {
  margin-top: 0.75rem;
  font-family: "Outfit", sans-serif;
  font-weight: 700;
  color: var(--gw-ink);
}

.paket-empty__sub {
  margin-top: 0.25rem;
  font-size: 0.88rem;
  color: var(--gw-muted);
}

.paket-mobile {
  padding: 0.85rem;
  display: grid;
  gap: 0.75rem;
}

.paket-mobile-card {
  border: 1px solid var(--gw-line);
  border-radius: 12px;
  padding: 0.9rem;
  background: #fff;
}

.paket-mobile-card__top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.5rem;
}

.paket-mobile-card__desc {
  margin-top: 0.75rem;
  padding-top: 0.75rem;
  border-top: 1px solid var(--gw-line);
  font-size: 0.88rem;
  color: var(--gw-muted);
}

.paket-menu {
  border-radius: 10px !important;
}

.paket-dialog-card {
  border-radius: 14px !important;
  overflow: hidden;
}

.paket-dialog-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.95rem 1.1rem;
  background:
    radial-gradient(120% 80% at 0% 0%, #1a6b4d 0%, transparent 55%),
    linear-gradient(175deg, #0b3d2e 0%, #0f5c45 45%, #0a3327 100%);
  color: #f4fbf7;
}

.paket-dialog-header__copy {
  display: flex;
  align-items: center;
  font-family: "Outfit", "Montserrat", sans-serif;
  font-weight: 600;
}

.paket-dialog-header__copy .v-icon {
  color: var(--gw-mint) !important;
}

.paket-dialog-body {
  padding: 1.25rem 1.25rem 0.5rem !important;
}

.paket-field-label {
  margin-bottom: 0.4rem;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--gw-forest);
}

.paket-field >>> .v-input__slot {
  border-radius: 10px !important;
}

.paket-field >>> .v-icon {
  color: var(--gw-leaf) !important;
}

.paket-price-preview {
  margin-top: 0.55rem;
  font-size: 0.85rem;
  color: var(--gw-muted);
}

.paket-price-preview strong {
  color: var(--gw-forest);
}

.paket-divider {
  border-color: var(--gw-line) !important;
}

.paket-dialog-actions {
  padding: 0.9rem 1.1rem !important;
  background: var(--gw-paper);
}

.paket-btn-ghost {
  color: var(--gw-muted) !important;
  text-transform: none !important;
  letter-spacing: 0 !important;
  font-weight: 600 !important;
}

@media (max-width: 600px) {
  .paket-toolbar__actions {
    width: 100%;
  }

  .paket-search {
    max-width: none;
    flex: 1;
    min-width: 0;
  }

  .paket-toolbar__actions .paket-btn-primary {
    width: 100%;
  }
}
</style>
